import { connect } from 'react-redux';

import ConfirmBooking from '../components/Create/ConfirmBooking';

const mapStateToProps = (state) => {
    const { newBooking } = state;
    const { user } = state.environment;
    const { plant, travelReasons, locations } = state.entities;

    return {
        user,
        plant,
        travelReasons,
        newBooking,
        locations
    };
};

export default connect(mapStateToProps)(ConfirmBooking);



// WEBPACK FOOTER //
// ./scripts/containers/ConfirmBookingContainer.jsx